<!-- src/app/components/header/header.component.html -->
<header>
  <div class="header-container">
    <div class="logo">
      <img src="/assets/Logo.png" alt="Lydia Christensen Logo" />
      <img class="logo-lp" src="/assets/Libertarian_Disc.svg" alt="Libertarian Party Logo" />
      <div>
        <h1>Lydia Christensen</h1>
        <span>Michigan's Unchained Voice</span>
      </div>
    </div>

    <nav class="desktop-nav">
      <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Home</a>
      <a routerLink="/about" routerLinkActive="active">About</a>
      <a routerLink="/issues" routerLinkActive="active">Issues</a>
      <a routerLink="/events" routerLinkActive="active">Events</a>
      <a routerLink="/newsroom" routerLinkActive="active">Newsroom</a>
      <a routerLink="/donate" routerLinkActive="active">Donate</a>

      <!-- More dropdown -->
      <div class="nav-more">
        <button class="nav-more__toggle" (click)="toggleMore()" [class.active]="isMoreOpen" [attr.aria-expanded]="isMoreOpen">
          More
          <svg viewBox="0 0 20 20" [class.flipped]="isMoreOpen"><path d="M5 8l5 5 5-5"/></svg>
        </button>
        <div class="nav-more__menu" *ngIf="isMoreOpen">
          <a routerLink="/merch"        routerLinkActive="active" (click)="closeMore()">Store</a>
          <a routerLink="/tracker"      routerLinkActive="active" (click)="closeMore()">Bill Tracker</a>
          <a routerLink="/report-card"  routerLinkActive="active" (click)="closeMore()">Delegation</a>
          <a routerLink="/endorsements" routerLinkActive="active" (click)="closeMore()">Endorsements</a>
          <a routerLink="/coalitions"   routerLinkActive="active" (click)="closeMore()">Coalitions</a>
          <a routerLink="/phone-bank"   routerLinkActive="active" (click)="closeMore()">Phone Bank</a>
          <a routerLink="/compare"      routerLinkActive="active" (click)="closeMore()">Compare</a>
          <a routerLink="/faq"          routerLinkActive="active" (click)="closeMore()">FAQ</a>
          <a routerLink="/press"        routerLinkActive="active" (click)="closeMore()">Press Kit</a>
        </div>
      </div>

      <a routerLink="/volunteer" routerLinkActive="active" class="nav-cta">Volunteer</a>
      <a routerLink="/contact"   routerLinkActive="active">Contact</a>
    </nav>

    <button class="mobile-toggle" (click)="toggleMenu()" aria-label="Toggle menu">
      <svg viewBox="0 0 24 24">
        <path [attr.d]="isOpen ? 'M6 18L18 6M6 6l12 12' : 'M4 6h16M4 12h16m-7 6h7'" />
      </svg>
    </button>
  </div>

  <nav *ngIf="isOpen" class="mobile-nav">
    <a routerLink="/"             routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" (click)="toggleMenu()">Home</a>
    <a routerLink="/about"        routerLinkActive="active" (click)="toggleMenu()">About</a>
    <a routerLink="/issues"       routerLinkActive="active" (click)="toggleMenu()">Issues</a>
    <a routerLink="/events"       routerLinkActive="active" (click)="toggleMenu()">Events</a>
    <a routerLink="/newsroom"     routerLinkActive="active" (click)="toggleMenu()">Newsroom</a>
    <a routerLink="/donate"       routerLinkActive="active" (click)="toggleMenu()">Donate</a>
    <a routerLink="/tracker"      routerLinkActive="active" (click)="toggleMenu()">Bill Tracker</a>
    <a routerLink="/report-card"  routerLinkActive="active" (click)="toggleMenu()">Delegation</a>
    <a routerLink="/endorsements" routerLinkActive="active" (click)="toggleMenu()">Endorsements</a>
    <a routerLink="/coalitions"   routerLinkActive="active" (click)="toggleMenu()">Coalitions</a>
    <a routerLink="/phone-bank"   routerLinkActive="active" (click)="toggleMenu()">Phone Bank</a>
    <a routerLink="/compare"      routerLinkActive="active" (click)="toggleMenu()">Compare</a>
    <a routerLink="/faq"          routerLinkActive="active" (click)="toggleMenu()">FAQ</a>
    <a routerLink="/press"        routerLinkActive="active" (click)="toggleMenu()">Press Kit</a>
    <a routerLink="/merch"        routerLinkActive="active" (click)="toggleMenu()">Store</a>
    <a routerLink="/volunteer"    routerLinkActive="active" (click)="toggleMenu()">Volunteer</a>
    <a routerLink="/contact"      routerLinkActive="active" (click)="toggleMenu()">Contact</a>
  </nav>
</header>
